import React from 'react'

export default function NotFound() {
  return <h1 style={{ color: 'white' }}>404 - Not Found</h1>
}
